import { useMemo } from "react";
import { firebaseHelper } from "ui/utils/firebase";
import { useSharingV2 } from "ui/utils/useDesignFirm";
import { sharingV2Known } from "ui/utils/workspace/sharingV2";
import { getActiveDesignFirmId, useWorkspaceStore } from "ui/utils/workspace";
import { activeTeamScope, type TeamScope } from "../v2/apis/accessQueries";

// The active team scope for list pages: non-null in a team workspace whose
// sharingV2 flag is on. Subscribes to the firm doc, so a flag flip re-renders.
export const useTeamScope = (uid: string | null | undefined): TeamScope | null => {
  const activeIdByUid = useWorkspaceStore((s) => s.activeIdByUid);
  const firmId = uid ? getActiveDesignFirmId(uid) : null;
  const { enabled } = useSharingV2(firebaseHelper.db, firmId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => activeTeamScope(uid), [uid, firmId, enabled, activeIdByUid]);
};

// False while the active team's flag is still loading on a cold load, so a
// list can hold its first query until it knows the shape; a failed firm read
// settles it too (the legacy query then runs).
export const useTeamScopeReady = (uid: string | null | undefined): boolean => {
  useWorkspaceStore((s) => s.activeIdByUid);
  const firmId = uid ? getActiveDesignFirmId(uid) : null;
  const { loading } = useSharingV2(firebaseHelper.db, firmId);
  return !firmId || sharingV2Known(firmId) || !loading;
};
